import * as d3 from 'd3-selection'

const lineHeight = 8.8
    , padding = {
        top: 1.3,
        bottom: 3
      }

function wrapper (selection, width) {
  selection.each(function () {
    let g = d3.select(this)
      , current = g.attr('data-labels')

    if (current === g.datum()) {
      // No need to wrap since the labels didn't change. This is a hack for
      // https://github.com/SpiderStrategies/Scoreboard/issues/25964
      return
    }

    let word, line = []
      , words = g.datum().split(/\s+/).reverse()
      , lineNumber = 0
      , dy = padding.top
      , text = g.html(null)
                .append('text')
                  .attr('x', 0)
                  .attr('y', 0)
                  .attr('dy', dy + 'px')

    while (word = words.pop()) {
      line.push(word)
      text.text(line.join(' '))

      if (text.node().getComputedTextLength() > width) {
        line.pop()
        text.text(line.join(' '))
        line = [word]
        text = g.append('text')
                  .attr('x', 0)
                  .attr('y', 0)
                  .attr('dy', ++lineNumber * lineHeight + dy + 'px')
                  .text(word)
      }
    }
  })
}

export default function (dimensions, field) {

  let draw = function (selection) {
    selection.each(function () {
      let text = d3.select(this)
                   .selectAll(`g.${field}`).data(function (d) {
                     let _field = d[field]
                     if (!_field) {
                       // No fields
                       return []
                     }
                     return Array.isArray(_field) ? d[field] : [d[field]]
                   })
      text.enter()
          .append('g')
            .attr('class', field)
            .merge(text)
            .each(function (d, i) {
              let node = d3.select(this)

              node.attr('transform', `translate(${dimensions.viewbox.width / 2}, ${dimensions.viewbox.height})`)
                  .call(wrapper, dimensions.width)
                  .attr('data-labels', String) // Store so we know previous labels on next render

              // adjust the viewbox height based on text height
              let textLines = node.selectAll('text')
              if (textLines.size()) {
                textLines.each(() => dimensions.viewbox.height += lineHeight)
                dimensions.viewbox.height += padding.top + padding.bottom
              }
      })

      text.exit().remove()
    })
  }

  return draw
}
